<script>
    export let width = 60;
    export let height = 45;
    export let color = "#fff";
</script>

<svg {width} {height} viewBox="0 0 512 512">
    <path
        d="M304 336v40a40 40 0 01-40 40H104a40 40 0 01-40-40V136a40 40 0 0140-40h152c22.09 0 48 17.91 48 40v40M368 336l80-80-80-80M176 256h256"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
    />
</svg>
